import { Button as BaseButton } from 'antd';
import React from 'react';
import styled from 'styled-components';

const Button = styled(BaseButton)`
  font-size: 16px;
  padding: 0px 9px;
`;

export interface FiltersToolbarButtonProps {
  disabled?: boolean;
  label: string;
  onClick?: () => void;
}

function FiltersToolbarButton({
  disabled,
  label,
  onClick,
}: FiltersToolbarButtonProps) {
  return (
    <Button disabled={disabled} onClick={onClick}>
      {label}
    </Button>
  );
}

export default FiltersToolbarButton;
